import { Injectable } from '@angular/core'
import { Actions, Effect, ofType } from '@ngrx/effects'
import { catchError, concatMap, map, switchMap, tap } from 'rxjs/operators'
import { of } from 'rxjs'
import { ExtraService } from './service'
import {
  AddExtra,
  AddExtraComplete,
  DeleteExtra,
  DeleteExtraComplete,
  DeleteExtras,
  DeleteExtrasComplete,
  LoadExtras,
  LoadExtrasByIds,
  LoadExtrasByIdsComplete,
  LoadExtrasComplete,
  UpdateExtra,
  UpdateExtraComplete,
} from './actions'
import { ActionFailed, Toaster } from '@tokeet-frontend/tv3-platform'

@Injectable()
export class ExtraEffects {
  @Effect()
  loadExtras$ = this.actions$.pipe(
    ofType(LoadExtras),
    switchMap(({ params, pagination }) =>
      this.extras.all(params, pagination).pipe(
        map((extras) => LoadExtrasComplete({ extras })),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  @Effect()
  loadExtrasByIds$ = this.actions$.pipe(
    ofType(LoadExtrasByIds),
    switchMap(({ ids }) =>
      this.extras.getByIds(ids).pipe(
        map((extras) => LoadExtrasByIdsComplete({ extras })),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  @Effect()
  addExtra$ = this.actions$.pipe(
    ofType(AddExtra),
    switchMap(({ payload }) =>
      this.extras.create(payload).pipe(
        map((extra) => AddExtraComplete({ extra })),

        tap(() => this.toast.success($localize`Extra created successfully.`)),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  @Effect()
  updateExtra$ = this.actions$.pipe(
    ofType(UpdateExtra),
    switchMap(({ payload, extraId }) =>
      this.extras.update(extraId, payload).pipe(
        map((extra) => UpdateExtraComplete({ update: { id: extraId, changes: extra } })),

        tap(() => this.toast.success($localize`Extra updated successfully.`)),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  @Effect()
  deleteExtra$ = this.actions$.pipe(
    ofType(DeleteExtra),
    switchMap(({ id }) =>
      this.extras.delete(id).pipe(
        map((extra) => DeleteExtraComplete({ id: extra.pkey })),
        tap(() => this.toast.success($localize`Extra deleted successfully.`)),

        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  @Effect()
  deleteExtras$ = this.actions$.pipe(
    ofType(DeleteExtras),
    concatMap(({ ids }) =>
      this.extras.deleteExtras(ids).pipe(
        map(() => DeleteExtrasComplete({ ids })),
        tap(() => this.toast.success($localize`Extras deleted successfully.`)),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  constructor(private actions$: Actions, private extras: ExtraService, private toast: Toaster) {}
}
